'use strict';

angular.module('app')
    .factory('Print', ['$resource', 'ME_CONFIG', function ($resource, ME_CONFIG) {
        return $resource(ME_CONFIG.apiBaseUrl + '/recipes/:id/printHistory', {}, {
            'getBatchesPastMonth': {method: 'GET', isArray: true, url: ME_CONFIG.apiBaseUrl + '/recipes/:id/printHistory/batchesPastMonth'},
            'get': {method: 'GET', isArray: true},
            'getPrepChefs': {method: 'GET', isArray: true, url: ME_CONFIG.apiBaseUrl + '/recipes/printHistory/prepChefs'},
            'print': {method: 'POST', url: ME_CONFIG.apiBaseUrl + '/recipes/printHistory'},
            'markPrintFail': {
                method: 'PUT',
                url: ME_CONFIG.apiBaseUrl + '/recipes/printHistory/:recipePrintHistoryId',
                hasBody: false
            },
            'getNextBatchNumber': {
                method: 'GET',
                url: ME_CONFIG.apiBaseUrl + '/recipes/printHistory/nextBatchNumber',
                transformResponse: function (data) {
                    return {
                        nextBatchNumber: parseInt(data, 10) || 1
                    }
                }
            }
        });
    }])
    .service('PrintService', ['Print', '$state', '$filter', 'StarPrinterService', 'EpsonPrinterService', '$translate', function (Print, $state, $filter, StarPrinterService, EpsonPrinterService, $translate) {
        var pageToLoad = {};
        var loadingDialog;
        var savedRecipePrintHistory;
        var TEST_SUCCESS_IP = 'test.i.will.pass';
        this.TEST_SUCCESS_IP = TEST_SUCCESS_IP;
        var TEST_FAIL_IP = 'test.i.will.fail';
        this.TEST_FAIL_IP = TEST_FAIL_IP;

        this.printerTypes = [{
            id: 'EPSON',
            friendlyName: 'Epson'
        }, {
            id: 'STAR',
            friendlyName: 'Star'
        }];

        var PrintTypes = {
            RECIPE: 'recipe',
            TIMESTAMP: 'timestamp'
        };
        this.PrintTypes = PrintTypes;
        
        this.testPrint = function (printerConfig) {
            var sampleText = $translate.instant('recipeViewer.print.samplePrepChefText');
            
            var testPrintSettings = {
                prepDate: new Date(),
                prepChef: sampleText,
                notes: null,
                expireDate: new Date(),
                quantity: 1,
                printerConfig: printerConfig
            };
            this.print(testPrintSettings, "Test recipe", {name: 'printerConfig'}, true);
        };

        var onPrintError = function (errorMessage) {
            loadingDialog.modal('hide');
            bootbox.alert({
                title: $translate.instant('recipeViewer.global.oops'),
                message: errorMessage,
                callback: function () {
                    //this will only be false for test prints
                    if (_.get(pageToLoad, 'name') !== 'printerConfig') {
                        $state.reload();
                    }
                },
                buttons: {
                    ok: {
                        label: $translate.instant("recipeViewer.global.ok")
                    }
                }
            });
            if (savedRecipePrintHistory) {
                Print.markPrintFail({recipePrintHistoryId: savedRecipePrintHistory.id});
            }
        };

        var onPrintSuccess = function () {
            loadingDialog.modal('hide');
            bootbox.alert({
                title: $translate.instant('recipeViewer.print.printSuccess'),
                message: $translate.instant('recipeViewer.print.printSuccessMsg'),
                callback: function () {
                    if (pageToLoad) {
                        $state.go(pageToLoad.name, pageToLoad.params);
                    }
                },
                buttons: {
                    ok: {
                        label: $translate.instant("recipeViewer.global.ok")
                    }
                }
            });
        };

        var printWithStar = function (printInfo, recipeName, type) {
            var promise;
            if (type === PrintTypes.RECIPE) {
                promise = StarPrinterService.printRecipeWithPrintHistory(printInfo, recipeName);
            } else if (type === PrintTypes.TIMESTAMP) {
                promise = StarPrinterService.printTimestamp(printInfo.printerConfig, printInfo.prepChef, printInfo.prepDate, printInfo.name, printInfo.quantity);
            }
            return promise;
        };

        var printWithEpson = function (printInfo, recipeName, type) {
            var promise;
            if (type === PrintTypes.RECIPE) {
                promise = EpsonPrinterService.printRecipeWithPrintHistory(printInfo, recipeName);
            } else if (type === PrintTypes.TIMESTAMP) {
                promise = EpsonPrinterService.printTimestamp(printInfo.printerConfig, printInfo.prepChef, printInfo.prepDate, printInfo.name, printInfo.quantity);
            }
            return promise;
        };

        var sendPrintRequestToPrinter = function (printInfo, recipeName, type) {
            if (printInfo.printerConfig.printerIpAddress.toLowerCase() === TEST_SUCCESS_IP) {
                setTimeout(function () {
                    onPrintSuccess();
                }, 2000);
                return;
            }
            if (printInfo.printerConfig.printerIpAddress.toLowerCase() === TEST_FAIL_IP) {
                setTimeout(function () {
                    onPrintError($translate.instant('recipeViewer.print.testFailMsg'));
                }, 2000);
                return;
            }

            var promise;
            switch (printInfo.printerConfig.printerType) {
                case 'STAR': {
                    promise = printWithStar(printInfo, recipeName, type);
                    break;
                }
                case 'EPSON': {
                    promise = printWithEpson(printInfo, recipeName, type);
                    break;
                }
                default: {
                    bootbox.alert({
                        title: $translate.instant('recipeViewer.global.oops'),
                        message: $translate.instant('recipeViewer.print.validPrinterMsg'),
                        buttons: {
                            ok: {
                                label: $translate.instant("recipeViewer.global.ok")
                            }
                        }
                    });
                }
            }
            
            if (promise) {
                promise.then(function () {
                    onPrintSuccess();
                }).catch(function (errorMessage) {
                    onPrintError(errorMessage);
                });
            }
        };

        this.print = function (printInfo, recipeName, givenPageToLoad, test) {
            pageToLoad = givenPageToLoad;
            savedRecipePrintHistory = null;
            var printingMsg = $translate.instant('recipeViewer.print.printing');
            loadingDialog = bootbox.dialog({
                message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> ' + printingMsg + ' </div>',
                closeButton: false
            });
            if (test) {
                sendPrintRequestToPrinter(printInfo, recipeName, PrintTypes.RECIPE);
                return;
            }
            var type = _.isNil(printInfo.recipe) ? PrintTypes.TIMESTAMP : PrintTypes.RECIPE;
            Print.print(printInfo).$promise.then(function (savedRecipePrintHistoryResult) {
                savedRecipePrintHistory = savedRecipePrintHistoryResult;
                sendPrintRequestToPrinter(printInfo, recipeName, type);
            }).catch(function () {
                loadingDialog.modal('hide');
                bootbox.alert({
                    title: $translate.instant('recipeViewer.global.oops'),
                    message: $translate.instant('recipeViewer.print.communicationToMEFailed'),
                    callback: function () {
                        $state.reload();
                    },
                    buttons: {
                        ok: {
                            label: $translate.instant("recipeViewer.global.ok")
                        }
                    }
                });
            });
        };
    }])
    .filter('dateFormatFilter', ['PrinterService', function (PrinterService) {
        return PrinterService.getDateStr;
    }]);